import _includes from "lodash/includes";
import _isArray from "lodash/isArray";
import { keyboardKey, SpacebarKey } from '../../keyboard-key';
export var popupBehavior = function popupBehavior(props) {
  var onAsArray = _isArray(props.on) ? props.on : [props.on];
  var tabbableTriggerProps = props.tabbableTrigger ? {
    tabIndex: getAriaAttributeFromProps('tabIndex', props, 0)
  } : undefined;
  if (tabbableTriggerProps) {
    var _props$trigger, _props$trigger2;
    tabbableTriggerProps['aria-haspopup'] = (_props$trigger = props.trigger) != null && _props$trigger.props.hasOwnProperty('aria-haspopup') ? (_props$trigger2 = props.trigger) == null ? void 0 : _props$trigger2.props['aria-haspopup'] : 'dialog';
    if (process.env.NODE_ENV !== 'production') {
      // Override the default trigger's accessibility schema class.
      tabbableTriggerProps['data-aa-class'] = 'PopupButton';
    }
  }
  return {
    attributes: {
      trigger: Object.assign({}, tabbableTriggerProps),
      popup: {
        role: props.trapFocus ? 'dialog' : props.inline ? undefined : 'complementary',
        'aria-modal': props.trapFocus ? true : undefined,
        'data-popup-trapfocus': props.trapFocus ? true : undefined
      }
    },
    keyActions: {
      popup: {
        closeAndFocusTrigger: {
          keyCombinations: [{
            keyCode: keyboardKey.Escape
          }]
        },
        preventScroll: {
          keyCombinations: props.isOpenedByRightClick && _includes(onAsArray, 'context') && [{
            keyCode: keyboardKey.ArrowDown
          }, {
            keyCode: keyboardKey.ArrowUp
          }, {
            keyCode: keyboardKey.PageDown
          }, {
            keyCode: keyboardKey.PageUp
          }, {
            keyCode: keyboardKey.Home
          }, {
            keyCode: keyboardKey.End
          }]
        }
      },
      trigger: {
        close: {
          keyCombinations: [{
            keyCode: keyboardKey.Escape
          }]
        },
        toggle: {
          keyCombinations: _includes(onAsArray, 'click') && [{
            keyCode: keyboardKey.Enter
          }, {
            keyCode: SpacebarKey
          }]
        },
        open: {
          keyCombinations: _includes(onAsArray, 'hover') && !_includes(onAsArray, 'context') && [{
            keyCode: keyboardKey.Enter
          }, {
            keyCode: SpacebarKey
          }]
        },
        click: {
          keyCombinations: _includes(onAsArray, 'hover') && !_includes(onAsArray, 'context') && [{
            keyCode: keyboardKey.Enter
          }, {
            keyCode: SpacebarKey
          }]
        }
      }
    }
  };
};
var isFocusable = function isFocusable(propsData) {
  try {
    var as = propsData.as,
      href = propsData.href,
      type = propsData.type;
    return type === 'button' || type === 'input' || type === 'a' && href !== undefined || as === 'button';
  } catch (_unused) {
    return false;
  }
};
var getAriaAttributeFromProps = function getAriaAttributeFromProps(attributeName, props, defaultValue) {
  if (!props.trigger) return undefined;
  if (props.trigger.props[attributeName]) {
    return props.trigger.props[attributeName];
  }
  var _props$trigger$props = props.trigger.props,
    as = _props$trigger$props.as,
    href = _props$trigger$props.href;
  var type = props.trigger.type;
  if (isFocusable({
    as: as,
    href: href,
    type: type
  })) {
    return undefined;
  }
  return defaultValue;
};
//# sourceMappingURL=popupBehavior.js.map
